<template>
	<button class="btn_today" @click="selectToday">오늘</button>
</template>

<script>
	import { mapActions } from 'vuex';

	export default {
		methods: {
			...mapActions(['selectToday']),
		},
	}
</script>
